module.exports = __webpack_public_path__ + "img/cancelled.7cd70d77.svg";